//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var costInfo;
//控制《报销单详情页面》费用详情显示隐藏
var infoShowHide = '';
var windowThis;
var windowBodyHeight;
var diagcostinfoList = '';
import { selectCostList, saveReExpeAcco, clearCostRelation, costTypeSelectList, saveCost, costTypeSelect, selectCostDetail, selectMainIdCostList, uploadCostImg, selectDictionType, getInvoceInfo, selectFillList, FILE_URL, InvoiceRise, InvoiceNumber, getInvoTypeList } from '@/api/rem/cost/cost';
import { guid, formatTime, convertToDate } from '@/common/common'
import { getPersonProjectData } from '@/api/pm/project';
import { DORM, JPT_URL, BASIC, DORM_URL } from "@/config/constant"
import promise from '@/axios/promise'
import { Toast } from 'mint-ui';
import SlipDel from 'vue-slip-delete'
var page = 1;
var limit = 10;
var dialogCostIndex = [];
var reimType = '';
export default {
	inject: ['reload'],
	components: {
		SlipDel
	},
	filters: { 
		numFilter(value) {
			//  	debugger;
			  // 截取当前数据到小数点后两位
			  
			let realVal = parseFloat(value).toFixed(2);   // num.toFixed(2)获取的是字符串
			  
			return realVal 
		},
		dateFilter(value) {
			return value.substring(0, value.length - 2)

		}
	},
	data() {
		return {
			data: {
				reimStyle: 'II类',
				creaTime: '',
				invoNumb: '',
				date: undefined,
				textarea: '',
				fid: '',
				reimCostNumb: 0,
				projName: '',
				projCode: '',
			},
			solo: true,
			//照片
			imgList: [],
			datas: new FormData(),
			files: 0,
			size: 0,
			imgUrl: [],
			dataList: [],
			checkbox: [],
			reimCostList: [],
			refreshing: false,
			loading: false,
			loadingDialog: false,
			createdCost: {
				userType: '',
				date: undefined,
				AtypeText: '',
				costType: '',
				costDate: '',
				options: ['暂未获取到任何数据'],
				dateOccu: '',
				amouMone: '',
				costIcon: '',
				bRemarks: '',
				invoType: ''
			},
			alert: false,
			exendFrom: {},
			costDetail: {},
			fillcreate: {
				fillCode: '',
				fillNumb: '',
				fillMone: '',
				fillTime: '',
				fillImg: '',
				fillImgUrl: ''
			},
			fillList: [{
				fillCode: '',
				fillNumb: '',
				fillMone: '',
				fillTime: '',
				fillImg: '',
				fillImgUrl: '',
				checkCode: '',
				subtotalAmount: '',
				taxRate: ''
			}],
			projectList: [],
			costTypeList: [],
			costTypefield: [],
			costInfoList: [],
			costInfofield: [],
			costfillList: [],
			diglogCreatedCost: true,
			file_URL: '',
			openSimple: false,
			// checkAll:false
			//发票弹出框
			invoiceDialogVisible: false,
			totalTaxSum: '',
			totalTaxNum: '',
			totalAmount: '',
			fillRise: '',
			fillNumber: '',
			InvoiceRise: InvoiceRise,
			InvoiceNumber: InvoiceNumber,
			// 费用类型中的默认税率
			defaultTaxRate: '',
			// 发票类型数据
			invoTypeOptions: [],

		}
	},
	watch: {
		'data.reimStyle': { // 这监听对象值的改变 和上面的不一样。
			handler(curVal, oldVal) {
				reimType = this.data.reimStyle;
				if(reimType == 'I类') {
					page = 1;
					limit = 10;
					var pageLimit = {
						'page': page,
						'limit': limit,
						'reimType': reimType
					}
					selectMainIdCostList(pageLimit).then(response => {
						console.log(response)
						this.dataList = response.data;
					})
					this.diglogCreatedCost = false;
				} else if(reimType == 'II类') {
					page = 1;
					limit = 10;
					var pageLimit = {
						'page': page,
						'limit': limit,
						'reimType': reimType
					}
					selectMainIdCostList(pageLimit).then(response => {
						console.log(response)
						this.dataList = response.data;
					})
					this.diglogCreatedCost = true;
				}
				// this.reimCostList=[];
			},
			deep: true,
		}
	},
	created() {
		// 获取配置数据
		this.getDicData();
		if(this.$route.query.reimData != undefined) {
			console.log(this.$route.query.reimData)
			this.data.reimStyle = this.$route.query.reimData.reimStyle;
			this.data.creaTime = this.$route.query.reimData.creaTime;
			this.data.invoNumb = this.$route.query.reimData.invoNumb;
			this.data.textarea = this.$route.query.reimData.reimRemark;
			this.data.projName = this.$route.query.reimData.projName;
			this.data.reimCostNumb = this.$route.query.reimData.reimCostNumb;
			this.data.projCode = this.$route.query.reimData.projCode;
			this.data.fid = this.$route.query.reimData.fid;
			this.reimCostList = this.$route.query.reimData.costInFo;
			console.log(this.reimCostList[0].hasOwnProperty('infoFid'))
			if(this.reimCostList[0].hasOwnProperty('infoFid') == false) {
				this.reimCostList = [];
			} else {

			}
		} else {
			var myDate = new Date()
			var year = myDate.getFullYear();
			var month = myDate.getMonth() + 1;
			if(month < 10) {
				month = '0' + month;
			}
			var day = myDate.getDate();
			if(day < 10) {
				day = '0' + day;
			}
			var hour = myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours();
			var minute = myDate.getMinutes() < 10 ? "0" + myDate.getMinutes() : myDate.getMinutes();
			var second = myDate.getSeconds() < 10 ? "0" + myDate.getSeconds() : myDate.getSeconds();
			var createDate = year + '-' + month + '-' + day + ' ' + hour + ":" + minute + ":" + second;
			this.data.creaTime = createDate;
			windowThis = this;
			diagcostinfoList = '';
		}

		//添加创建日期
		this.getData();
		var condition = {
			"personCode": ""
		};
		getPersonProjectData().then(response => {
			for(var i = 0; i < response.list.length; i++) {
				var proj = {};
				proj.projCode = response.list[i].projCode;
				proj.projName = response.list[i].projName;
				this.projectList.push(proj)
			}
			console.log(this.projectList)
		});

		//获取滴滴信息
		page = 1;
		limit = 10;
		var pageLimit = {
			'page': page,
			'limit': limit,
			'reimType': 'II类'
		}
		selectMainIdCostList(pageLimit).then(response => {
			console.log(response)
			this.dataList = response.data;
		})
		reimType = this.data.reimType;
		this.diglogCreatedCost = true;
		promise({
			url: DORM + "/expense/selectDictionType",
			method: "get",
			async: false,
			params: {
				type: "fileUrl"
			}
		}).then(res => {
			console.log(res);
			this.file_URL = res[0].dicCode
		});
	},
	mounted() {
		//  $('.formDate').datetimepicker({
		//                   language:  'zh-CN',
		//                   weekStart: 1,
		//                   todayBtn:  1,
		//                   autoclose: 1,
		//                   todayHighlight: 1,
		//                   startView: 2,
		//                   minView: 2,
		//                   forceParse: 0
		//                   });
		console.log($('.container').height())
		// $('.loadingHeight').css('min-height',$('.container').height()+57)
		$('.loadingInfoHeight').css('min-height', $('.container').height() + 57)
		windowBodyHeight = document.body.clientHeight;
	},
	methods: {

		// 日期格式化
		dateFormatter(date, format) {
			return formatTime(date, format);
		},
		//获取报销单的图标
		getRembIcon(reimCostList) {
			var costIcon = '';
			var iconArr = [];
			for(var i = 0; i < reimCostList.length; i++) {
				var icon = reimCostList[i].costIcon;
				if(iconArr.indexOf(icon) == -1) {
					iconArr.push(icon);
				}
			}
			for(var i = 0; i < iconArr.length; i++) {
				if(i == 0) {
					costIcon = iconArr[i];
				} else {
					costIcon += ',' + iconArr[i];
				}
			}
			return costIcon;
		},
		reimStyleA() {
			var reimType = this.data.reimStyle;
			if(this.reimCostList.length == 0) {

			} else {
				Toast({
					message: '请先删除现有费用',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				this.data.reimStyle = 'II类'
				return;
			}
		},
		reimStyleB() {
			var reimType = this.data.reimStyle;
			if(this.reimCostList.length == 0) {

			} else {
				Toast({
					message: '请先删除现有费用',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				this.data.reimStyle = 'I类'
				return;
			}
		},
		// checkAllChange(){
		//   if(this.checkAll==true){
		//     this.checkbox=true;
		//     console.log(dialogCostIndex)
		//   }
		// },
		InvoiceInfoDialog() {
			$('.invoiceDialogVisible').css('display', 'none');
		},
		dialogCostTypeB() {
			// setTimeout(function(){
			//   var divHeight=$('.costHeight').height();
			//   if(divHeight>windowBodyHeight){
			//     $('.loadingHeight').css('min-height',divHeight)
			//   }
			// },100)
		},
		dialogCostTypeA() {
			// setTimeout(function(){
			//   var divHeight=$('.costHeight').height();
			//   if(divHeight>windowBodyHeight){
			//     $('.loadingHeight').css('min-height',divHeight)
			//   }
			// },100)
		},
		closeSimpleDialog() {
			$('.openSimple').css('display', 'none')
		},
		fillRemark() {
			$('.openSimple').css('display', 'block')
		},
		backList() {
			this.$router.push({
				path: '/app/remb/reimList'
			})
		},
		//获取费用类型
		getData: function() {
			costTypeSelectList().then(response => {
				var json = [];
				for(var i = 0; i < response.data.length; i++) {
					var j = response.data[i];
					var item = {
						'costTypeName': j.costName,
						'taxRate': j.taxRate
					};
					json.push(item);
				}
				this.createdCost.options = json;
			});
		},
		// 获取配置数据
		getDicData() {
			// 获取发票类型数据
			getInvoTypeList().then(response => {
				this.invoTypeOptions = response;
			});
		},
		// 发票类型改变事件
		changeInvoTypeEvent(value) {
			let obj = {};
			obj = this.invoTypeOptions.find((item) => {
				return item.invoTypeCode === value;
			});
			this.fillList[0].invoTypeName = (obj === undefined ? '' : obj.invoiceType);
			this.fillList[0].isCheck = (obj === undefined ? '' : obj.isCheck);
		},
		//添加费用
		costImgClick() {
			$('.dialogDiv').show();
			$('.container').css('padding-bottom', '0px')
			$('.dialogDiv').animate({
				bottom: '0%'
			}, 500)
			setTimeout(function() {
				$('.costListDiv').css('display', 'none')
			}, 500)

		},
		//新建费用
		createdCost1() {
			setTimeout(function() {
				$('.costDiloagListDiv').css('display', 'none')
			}, 100)
			$('.costListDiv').css('display', 'none')
			$('.createdCost').show();
			$('.createdCost').animate({
				bottom: '0.1%'
			}, 500)
			var myDate = new Date()
			this.createdCost.costDate = formatTime(myDate, 'yyyy-MM-dd hh:mm:ss');
			this.fillList = [{
				fillCode: '',
				fillNumb: '',
				fillMone: '',
				fillTime: '',
				fillImg: '',
				fillImgUrl: '',
				checkCode: '',
				subtotalAmount: '',
				taxRate: ''
			}];
			setTimeout(function() {
				$('.fillImg').addClass('displNone')
			}, 100)
		},
		//初始添加费用
		openFullscreenDialog() {
			reimType = this.data.reimStyle;
			if(reimType == '') {
				Toast({
					message: '请选择费用类型',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				return;
			}
			$('.dialogDiv').show();
			$('.container').css('padding-bottom', '0px')
			$('.dialogDiv').animate({
				bottom: '0%'
			}, 500)
			setTimeout(function() {
				$('.costListDiv').css('display', 'none')
			}, 500)
		}, //弹出框返回
		closeFullscreenDialog() {
			$('.dialogDiv').animate({
				bottom: '-120%'
			}, 500)
			setTimeout(function() {
				$('.dialogDiv').hide()
			}, 500)
			// this.diglogCreatedCost=true;
			$('.container').css('padding-bottom', '56px')
			$('.costListDiv').css('display', 'block')
			dialogCostIndex = [];
		},
		//新建费用返回
		costDialog() {
			$('.costListDiv').css('display', 'block')
			$('.createdCost').animate({
				bottom: '-120%'
			}, 500)
			$('.costDiloagListDiv').css('display', 'block')
			setTimeout(function() {
				$('.createdCost').hide()
			}, 500)
			// page=1;
			// limit=10;
			// var pageLimit={'page':page,'limit':limit}
			// selectMainIdCostList(pageLimit).then(response =>{
			//   console.log(response)
			//   this.dataList=response.data;
			// })
		},
		//弹出框确认
		saveCloseFullscreenDialog() {
			$('.dialogDiv').animate({
				bottom: '-120%'
			}, 500)
			$('.container').css('padding-bottom', '56px')
			$('.costListDiv').css('display', 'block')
			setTimeout(function() {
				$('.dialogDiv').hide()

			}, 500)
			//把数据添加到costList
			for(var i = 0; i < dialogCostIndex.length; i++) {
				var Index = dialogCostIndex[i]
				var data = this.dataList[Index]
				var costNumb = this.numAdd(this.data.reimCostNumb, this.dataList[Index].amouMone)
				this.data.reimCostNumb = Number(costNumb).toFixed(2)
				this.reimCostList.push(data)

			}
			// this.data.reimCostNumb=this.numFilter(this.data.reimCostNumb);
			//移除弹出框的数据
			// dialogCostIndex=this.sort(dialogCostIndex)
			// for(var i=dialogCostIndex.length-1;i>=0;i--){
			//    var Index=dialogCostIndex[i]
			//    this.dataList.splice(Index,1)
			// }
			for(var i = 0; i < this.checkbox.length; i++) {
				if(diagcostinfoList == '') {
					diagcostinfoList = this.checkbox[i]
				} else {
					diagcostinfoList += ',' + this.checkbox[i]
				}
			}
			console.log('diagcostinfoList')
			console.log(diagcostinfoList)
			page = 1;
			limit = 10;
			var pageLimit = {
				'page': page,
				'limit': limit,
				'reimType': reimType,
				'reimCost': diagcostinfoList
			}
			selectMainIdCostList(pageLimit).then(response => {
				console.log(response)
				this.dataList = response.data;
			})
			dialogCostIndex = [];
			this.checkbox = [];
			console.log('reimCostList')
			console.log(this.reimCostList);
			this.costInfoList = [];
			this.costfillList = [];
		},
		//列表条数
		refresh() {
			// this.refreshing = true;
			// this.$refs.container.scrollTop = 0;
			// this.refreshing = false;
			// this.loading = false;
		},
		load() {
			page++;
			console.log(page);
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
				var pageLimit = {
					'page': page,
					'limit': limit,
					'reimType': reimType,
					'reimCost': diagcostinfoList
				}
				selectMainIdCostList(pageLimit).then(response => {
					console.log(response)
					if(response.data.length != '0') {
						for(var i = 0; i < response.data.length; i++) {
							this.dataList.push(response.data[i])
						}
					}
				})
			}, 500)
		},
		//勾选
		check(fid, row, dataList) {
			console.log('1111')
			console.log(this.checkbox)
			dialogCostIndex.push(row);
			dialogCostIndex = this.uniq(dialogCostIndex);
		},
		//滑动
		slipOpen(vm) {
			// 无需手动关闭
		},
		del(index) {
			// 删除回调
			var costId = this.reimCostList[index].infoFid;
			var moneNumb = this.numSub(this.data.reimCostNumb, this.reimCostList[index].amouMone)
			this.data.reimCostNumb = Number(moneNumb).toFixed(2)
			// console.log(this.reimCostList[index])
			// this.dataList.push(this.reimCostList[index])
			var costinfoArr = diagcostinfoList.split(',');
			for(var i = 0; i < this.reimCostList.length; i++) {
				if(costinfoArr[i] == this.reimCostList[index].infoFid) {
					costinfoArr.splice(i, 1);
					diagcostinfoList = costinfoArr.join(',');
					this.reimCostList.splice(index, 1)
					page = 1;
					limit = 10;
					var pageLimit = {
						'page': page,
						'limit': limit,
						'reimType': reimType,
						'reimCost': diagcostinfoList
					}
					selectMainIdCostList(pageLimit).then(response => {
						console.log(response)
						this.dataList = response.data;
					})
				}
			}
			this.costInfoList = [];
			this.costfillList = [];
			if(this.data.fid != '') {
				var fid = {
					'fid': costId
				}
				clearCostRelation(fid).then(response => {
					console.log(response)
					//把删除的数据添加到费用列表中

				})
			}
		},
		//报销单保存
		saveReim() {
			if(this.reimCostList == '' || this.reimCostList == null) {
				Toast({
					message: '请填写费用信息',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				// var data={};
				// data.reimCostNumb=this.data.reimCostNumb;
				// var reimData={reimburse:JSON.stringify(data)}
				//   console.log(reimData);
				//   saveReExpeAcco(reimData).then(respones=>{
				//     console.log(respones)
				//   })
				return;
			}
			$('.newCost').attr('disabled', 'disabled')
			var data = {};
			data.reimStyle = this.data.reimStyle;
			data.creaTime = this.data.creaTime;
			data.invoNumb = this.data.invoNumb;
			data.reimRemark = this.data.textarea;
			data.projName = this.data.projName;
			data.projCode = this.data.projCode;
			data.costInFo = this.reimCostList;
			//-------图标去重-----------
			// var costIcon='';
			// for(var i=0;i<this.reimCostList.length;i++){
			//   if(i==0){
			//     costIcon=this.reimCostList[i].costIcon;
			//   }else{
			//     costIcon+=','+this.reimCostList[i].costIcon;
			//   }
			// }
			var costIcon = this.getRembIcon(this.reimCostList);
			//-------------------------
			data.costIcon = costIcon;
			data.fid = this.data.fid;
			data.submitType = 'save';
			data.reimCostNumb = this.data.reimCostNumb;
			var reimData = {
				reimburse: JSON.stringify(data)
			}
			console.log(reimData);
			saveReExpeAcco(reimData).then(respones => {
				console.log(respones)
				Toast({
					message: '保存成功',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				this.$router.push({
					path: '/app/remb/reimList'
				})
				$('.newCost').removeAttr('disabled')
			})
		},
		//报销单提交
		submitReim() {
			if(this.data.projCode == '') {
				Toast({
					message: '请填写项目名称',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				return;
			}
			if(this.reimCostList == '' || this.reimCostList == null) {
				Toast({
					message: '请填写费用信息',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				return;
			}
			$('.newCost').attr('disabled', 'disabled')
			var data = {};
			data.reimStyle = this.data.reimStyle;
			data.creaTime = this.data.creaTime;
			data.invoNumb = this.data.invoNumb;
			data.reimRemark = this.data.textarea;
			data.projName = this.data.projName;
			data.projCode = this.data.projCode;
			data.costInFo = this.reimCostList;
			//-------图标去重-----------
			// var costIcon='';
			// for(var i=0;i<this.reimCostList.length;i++){
			//   if(i==0){
			//     costIcon=this.reimCostList[i].costIcon;
			//   }else{
			//     costIcon+=','+this.reimCostList[i].costIcon;
			//   }
			// }
			var costIcon = this.getRembIcon(this.reimCostList);
			//-------------------------
			data.costIcon = costIcon;
			data.fid = this.data.fid;
			data.submitType = 'submit';
			data.reimCostNumb = this.data.reimCostNumb;
			var reimData = {
				reimburse: JSON.stringify(data)
			}
			console.log(reimData);
			saveReExpeAcco(reimData).then(respones => {
				console.log(respones)
				if(respones.code == 0) {
					Toast({
						message: '提交成功',
						position: 'top',
						duration: 1500,
						className: "success"
					});
					$('.newCost').removeAttr('disabled')
					this.$router.push({
						path: '/app/remb/reimList'
					})
				} else {
					Toast({
						message: respones.msg,
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled')
				}
			})

		},
		//费用保存
		saveCost() {
			$('.newCost').attr('disabled', 'disabled');
			if(this.createdCost.costType == '' || this.createdCost.costDate == '' || this.createdCost.amouMone == '' || this.createdCost.userType == '') {
				// this.alert=true;
				Toast({
					message: '请填写基本信息',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			}
			if(this.data.userType == 'A类') {
				if(this.data.atypeText == '' || this.data.atypeText == undefined) {
					Toast({
						message: '请填写备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
			} else if(this.data.userType == 'B类') {
				if((this.data.bRemarks == '' || this.data.atypeText == undefined) && (this.data.atypeText == '' || this.data.atypeText == undefined)) {
					Toast({
						message: '请填写备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
				if(this.data.atypeText == '' || this.data.atypeText == undefined) {
					Toast({
						message: '请填写A类备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
				if(this.data.bRemarks == '' || this.data.atypeText == undefined) {
					Toast({
						message: '请填写B类备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
			}
			var data = {};
			data.userType = this.createdCost.userType;
			data.costType = this.createdCost.costType;
			data.costDate = this.createdCost.costDate;
			data.dateOccu = this.createdCost.dateOccu;
			data.amouMone = this.createdCost.amouMone;
			data.AtypeText = this.createdCost.AtypeText;
			data.bRemarks = this.createdCost.bRemarks;
			data.costIcon = this.createdCost.costIcon;
			data.invoType = this.createdCost.invoType;
			data.infoFid = guid();
			for(var i = 0; i < this.costTypefield.length; i++) {
				if(this.costTypefield[i].field == 'MULT_SELE_EXTE1') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else if(this.costTypefield[i].field == 'MULT_SELE_EXTE2') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else if(this.costTypefield[i].field == 'MULT_SELE_EXTE3') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else if(this.costTypefield[i].field == 'MULT_SELE_EXTE4') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else {
					var singName = this.costTypefield[i].field;
					data[singName] = this.costTypefield[i].value;
				}
			}
			// console.log(data);
			if(this.fillList != undefined && this.fillList.length != 0) {
				for(var i = 0; i < this.fillList.length; i++) {
					delete this.fillList[i].fillImg;
				}
				console.log('fill')
				console.log(this.fillList)
			} else {
				// MessageBox('提示', '请填写发票信息');
				// return;
			}
			var fillMone = 0;
			this.fillList.find((item) => {
				fillMone += parseFloat(item.fillMone)
			})

			// 判断是否选择了发票类型
			var invoTypeCode = this.fillList[0].invoTypeCode;
			if(invoTypeCode === null || invoTypeCode === undefined || invoTypeCode === '') {
				Toast({
					message: '请选择发票类型',
					position: 'top',
					duration: 1500,
					className: "warning"
				});
				return;
			}

			var fillmoneY = this.numAdd(parseFloat(this.fillList[0].taxRate), parseFloat(this.fillList[0].subtotalAmount));

			if(fillMone.toFixed(2) !== fillmoneY.toFixed(2) && invoTypeCode === '001') {
				Toast({
					message: '价税合计必须等于（税额+金额（不含税））',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			}
			if(isNaN(fillMone)) {
				Toast({
					message: '请填写价税合计',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			} else if(parseFloat(this.createdCost.amouMone) > fillMone) {
				Toast({
					message: '价税合计不得小于费用金额',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			}

			/************************************发票验证及保存*******************************/
			data.fillTime = this.fillList[0].fillTime;
			if(this.fillList[0].isCheck !== '是') {
				// 不需要发票验证
				data.invoStatus = '无需验证';
				data.invoInfo = '';
				var _this = this;
				var data1 = {
					'reCostinfo': data,
					'fillList': JSON.stringify(this.fillList)
				}
				saveCost(data1).then(response => {
					if(response == 400) {
						Toast({
							message: '同一张发票请勿重复使用',
							position: 'top',
							duration: 1500,
							className: "success"
						});
						$('.newCost').removeAttr('disabled');
						return true;
					} else {
						data.costDate = data.costDate + '00'
						_this.reimCostList.push(data)
						if(diagcostinfoList == '') {
							diagcostinfoList = data.infoFid
						} else {
							diagcostinfoList += ',' + data.infoFid
						}
						var moneNumb = this.numAdd(_this.data.reimCostNumb, data.amouMone)
						_this.data.reimCostNumb = Number(moneNumb).toFixed(2)
						Toast({
							message: '保存成功',
							position: 'top',
							duration: 1500,
							className: "success"
						});
						$('.newCost').removeAttr('disabled');
						_this.costToole();
					}
				});

				return;
			}

			/*******************需要发票验证***********************/
			var validationFillNumb = this.fillList[0].fillNumb;
			var validationFillCode = this.fillList[0].fillCode;
			var CheckCode = this.fillList[0].checkCode;
			var validationCheckCode = CheckCode.substring(14);
			var validationSubtotalAmount = this.fillList[0].subtotalAmount;
			var validationTime = convertToDate(this.fillList[0].fillTime);
			this.fillList[0].fillTime = validationTime;
			var validationFillTime = validationTime;
			var InvoceCheckParamVo = {
				'invoiceCode': validationFillCode,
				'invoiceNumber': validationFillNumb,
				'billTime': validationFillTime,
				'checkCode': validationCheckCode,
				'invoiceAmount': validationSubtotalAmount
			}
			console.log(InvoceCheckParamVo)
			promise({
				url: DORM + "/expense/invoce/check",
				method: "post",
				async: false,
				params: InvoceCheckParamVo

			}).then(res => {
				console.log(res);
				var resParse = JSON.parse(res.data)
				if(resParse.RtnCode == '00') {
					if(resParse.resultCode == '1000') {
						//totalTaxSum 价税合计
						//totalTaxNum 税额
						//totalAmount 金额
						console.log(resParse)
						var fillInfo = JSON.parse(resParse.invoiceResult);
						this.totalTaxSum = fillInfo.totalTaxSum;
						this.totalTaxNum = fillInfo.totalTaxNum;
						this.totalAmount = fillInfo.totalAmount;
						this.fillRise = fillInfo.purchaserName;
						this.fillNumber = fillInfo.taxpayerNumber;
						if(parseFloat(fillInfo.totalTaxSum) == parseFloat(this.fillList[0].fillMone) && parseFloat(fillInfo.totalTaxNum) == parseFloat(this.fillList[0].taxRate) && parseFloat(fillInfo.totalAmount) == parseFloat(this.fillList[0].subtotalAmount) && InvoiceRise == fillInfo.purchaserName && InvoiceNumber == fillInfo.taxpayerNumber) {

							// this.$message('发票验证通过');
							data.invoStatus = '验证已通过'
							data.invoInfo = resParse.resultMsg
							var _this = this;
							var data1 = {
								'reCostinfo': data,
								'fillList': JSON.stringify(this.fillList)
							}
							saveCost(data1).then(response => {
								console.log(response)
								if(response == 400) {
									Toast({
										message: '同一张发票请勿重复使用',
										position: 'top',
										duration: 1500,
										className: "success"
									});
									$('.newCost').removeAttr('disabled');
									return;
								} else {
									data.costDate = data.costDate + '00'
									_this.reimCostList.push(data)
									if(diagcostinfoList == '') {
										diagcostinfoList = data.infoFid
									} else {
										diagcostinfoList += ',' + data.infoFid
									}
									var costNumb = this.numAdd(_this.data.reimCostNumb, data.amouMone)
									_this.data.reimCostNumb = Number(costNumb).toFixed(2)
									Toast({
										message: '保存成功',
										position: 'top',
										duration: 1500,
										className: "success"
									});
									$('.newCost').removeAttr('disabled');
									_this.costToole();
								}

							});

						} else {
							if(InvoiceRise != fillInfo.purchaserName || InvoiceNumber != fillInfo.taxpayerNumber) {
								$('.invoiceDialogVisible').css('display', 'block');
								$('.newCost').removeAttr('disabled');
								return true;
							} else {
								this.fillList[0].fillMone = fillInfo.totalTaxSum;
								this.fillList[0].taxRate = fillInfo.totalTaxNum;
								this.fillList[0].subtotalAmount = fillInfo.totalAmount;
								data.invoStatus = '验证已通过'
								data.invoInfo = resParse.resultMsg
								var _this = this;
								var data1 = {
									'reCostinfo': data,
									'fillList': JSON.stringify(this.fillList)
								}
								saveCost(data1).then(response => {
									console.log(response)
									if(response == 400) {
										Toast({
											message: '同一张发票请勿重复使用',
											position: 'top',
											duration: 1500,
											className: "success"
										});
										$('.newCost').removeAttr('disabled');
										return;
									} else {
										data.costDate = data.costDate + '00'
										_this.reimCostList.push(data)
										if(diagcostinfoList == '') {
											diagcostinfoList = data.infoFid
										} else {
											diagcostinfoList += ',' + data.infoFid
										}
										var moneNumb = this.numAdd(_this.data.reimCostNumb, data.amouMone)
										_this.data.reimCostNumb = Number(moneNumb).toFixed(2);
										Toast({
											message: '保存成功',
											position: 'top',
											duration: 1500,
											className: "success"
										});
										$('.newCost').removeAttr('disabled');
										_this.costToole();
									}

								});

							}
						}
					} else if(resParse.resultCode == '2001') {
						// this.$message(resParse.resultMsg);
						data.invoStatus = '验证未通过'
						data.invoInfo = resParse.resultMsg
						var _this = this;
						var data1 = {
							'reCostinfo': data,
							'fillList': JSON.stringify(this.fillList)
						}
						saveCost(data1).then(response => {
							if(response == 400) {
								Toast({
									message: '同一张发票请勿重复使用',
									position: 'top',
									duration: 1500,
									className: "success"
								});
								$('.newCost').removeAttr('disabled');
								return;
							} else {
								console.log(response)
								data.costDate = data.costDate + '00'
								_this.reimCostList.push(data)
								if(diagcostinfoList == '') {
									diagcostinfoList = data.infoFid
								} else {
									diagcostinfoList += ',' + data.infoFid
								}
								var moneNumb = this.numAdd(_this.data.reimCostNumb, data.amouMone)
								_this.data.reimCostNumb = Number(moneNumb).toFixed(2)
								Toast({
									message: '保存成功',
									position: 'top',
									duration: 1500,
									className: "success"
								});
								$('.newCost').removeAttr('disabled');
								_this.costToole();
							}

						});

					}
				} else if(resParse.RtnCode == '99') {
					// this.$message(resParse.resultMsg);
					data.invoStatus = '未验证'
					data.invoInfo = resParse.resultMsg
					var _this = this;
					var data1 = {
						'reCostinfo': data,
						'fillList': JSON.stringify(this.fillList)
					}
					saveCost(data1).then(response => {
						if(response == 400) {
							Toast({
								message: '同一张发票请勿重复使用',
								position: 'top',
								duration: 1500,
								className: "success"
							});
							$('.newCost').removeAttr('disabled');
							return true;
						} else {
							console.log(response)
							data.costDate = data.costDate + '00'
							_this.reimCostList.push(data)
							if(diagcostinfoList == '') {
								diagcostinfoList = data.infoFid
							} else {
								diagcostinfoList += ',' + data.infoFid
							}
							var moneNumb = this.numAdd(_this.data.reimCostNumb, data.amouMone)
							_this.data.reimCostNumb = Number(moneNumb).toFixed(2)
							Toast({
								message: '保存成功',
								position: 'top',
								duration: 1500,
								className: "success"
							});
							$('.newCost').removeAttr('disabled');
							_this.costToole();
						}

					});

				}

				// this.fileUrl = res[0].dicCode
			});
		},
		//保存并新建
		saveAndCreate() {
			$('.newCost').attr('disabled', 'disabled')
			if(this.createdCost.costType == '' || this.createdCost.costDate == '' || this.createdCost.amouMone == '' || this.createdCost.userType == '') {
				// this.alert=true;
				Toast({
					message: '请填写基本信息',
					position: 'top',
					duration: 1500,
					className: "error"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			}
			if(this.data.userType == 'A类') {
				if(this.data.atypeText == '' || this.data.atypeText == undefined) {
					Toast({
						message: '请填写备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
			} else if(this.data.userType == 'B类') {
				if((this.data.bRemarks == '' || this.data.atypeText == undefined) && (this.data.atypeText == '' || this.data.atypeText == undefined)) {
					Toast({
						message: '请填写备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
				if(this.data.atypeText == '' || this.data.atypeText == undefined) {
					Toast({
						message: '请填写备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
				if(this.data.bRemarks == '' || this.data.atypeText == undefined) {
					Toast({
						message: '请填写备注',
						position: 'top',
						duration: 1500,
						className: "error"
					});
					$('.newCost').removeAttr('disabled');
					return true;
				}
			}
			var data = {};
			data.userType = this.createdCost.userType;
			data.costType = this.createdCost.costType;
			data.costDate = this.createdCost.costDate;
			data.dateOccu = this.createdCost.dateOccu;
			data.amouMone = this.createdCost.amouMone;
			data.AtypeText = this.createdCost.AtypeText;
			data.bRemarks = this.createdCost.bRemarks;
			data.costIcon = this.createdCost.costIcon;
			data.invoType = this.createdCost.invoType;
			data.infoFid = guid();
			console.log(costInfo.costTypeMinor)
			for(var i = 0; i < this.costTypefield.length; i++) {
				if(this.costTypefield[i].field == 'MULT_SELE_EXTE1') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else if(this.costTypefield[i].field == 'MULT_SELE_EXTE2') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else if(this.costTypefield[i].field == 'MULT_SELE_EXTE3') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else if(this.costTypefield[i].field == 'MULT_SELE_EXTE4') {
					var singName = this.costTypefield[i].field;
					var Value;
					for(var k = 0; k < this.costTypefield[i].value.length; k++) {
						if(k == 0) {
							Value = this.costTypefield[i].value[0];
						} else {
							Value += ',' + this.costTypefield[i].value[k]
						}
					}
					data[singName] = Value;
				} else {
					var singName = this.costTypefield[i].field;
					data[singName] = this.costTypefield[i].value;
				}
			}
			console.log(data)
			if(this.fillList != undefined && this.fillList.length != 0) {
				for(var i = 0; i < this.fillList.length; i++) {
					delete this.fillList[i].fillImg;
				}
				console.log('fill')
				console.log(this.fillList)
			} else {
				// MessageBox('提示', '请填写发票信息');
				// return;
			}
			var fillMone = 0;
			this.fillList.find((item) => {
				fillMone += parseFloat(item.fillMone)
			})
			var fillmoneY = this.numAdd(parseFloat(this.fillList[0].taxRate), parseFloat(this.fillList[0].subtotalAmount));
			if(fillMone.toFixed(2) !== fillmoneY.toFixed(2) && this.fillList[0].invoTypeCode === '001') {
				Toast({
					message: '价税合计必须等于（税额+金额（不含税））',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			}
			if(isNaN(fillMone)) {
				Toast({
					message: '请填写价税合计',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			} else if(parseFloat(this.createdCost.amouMone) > fillMone) {
				Toast({
					message: '价税合计不得小于费用金额',
					position: 'top',
					duration: 1500,
					className: "success"
				});
				$('.newCost').removeAttr('disabled');
				return true;
			}
			// if(this.fillList[0].subtotalAmount==''||this.fillList[0].taxRate==''||this.fillList[0].fillMone==''){
			//          if(this.fillList[0].subtotalAmount==''&&this.fillList[0].taxRate==''&&this.fillList[0].fillMone==''){
			//            this.$message('请填写发票金额相关信息');
			//            return true;
			//          }

			//          if(this.fillList[0].subtotalAmount==''&&this.fillList[0].taxRate==''){
			//            this.$message('请填写发票金额以及税额');
			//            return true;
			//          }else if(this.fillList[0].subtotalAmount==''&&this.fillList[0].fillMone==''){
			//            this.$message('请填写发票金额以及税价合计');
			//            return true;
			//          }else if(this.fillList[0].taxRate==''&&this.fillList[0].fillMone==''){
			//            this.$message('请填写税额以及税价合计');
			//            return true;
			//          }
			//          if(this.fillList[0].subtotalAmount==''){
			//             this.$message('请填写发票金额');
			//             return true;
			//          }else if(this.fillList[0].taxRate==''){
			//             this.$message('请填写税额');
			//             return true;
			//          }else if(this.fillList[0].fillMone==''){
			//            this.$message('请填写价税合计');
			//            return true;
			//          }

			//        }
			// var fillMoneSum=this.numAdd(parseFloat(this.fillList[0].subtotalAmount),parseFloat(this.fillList[0].taxRate))
			// console.log(fillMoneSum)
			// if(parseFloat(this.fillList[0].fillMone)!=fillMoneSum){
			//   this.$message('发票金额信息不对等');
			//   return true;
			//  }
			//  if(isNaN(fillMone)){
			//      this.$message('请填写发票金额');
			//      return true;
			//  }else if(parseInt(this.data.amouMone)>fillMone){
			//   this.$message('发票总金额不得小于费用金额');
			//   return true;
			// }
			var validationFillNumb = this.fillList[0].fillNumb;
			var validationFillCode = this.fillList[0].fillCode;
			var CheckCode = this.fillList[0].checkCode;
			var validationCheckCode = CheckCode.substring(14);
			var validationSubtotalAmount = this.fillList[0].subtotalAmount;
			var validationTime = convertToDate(this.fillList[0].fillTime);
			this.fillList[0].fillTime = validationTime;
			var validationFillTime = validationTime;
			var InvoceCheckParamVo = {
				'invoiceCode': validationFillCode,
				'invoiceNumber': validationFillNumb,
				'billTime': validationFillTime,
				'checkCode': validationCheckCode,
				'invoiceAmount': validationSubtotalAmount
			}
			console.log(InvoceCheckParamVo)
			promise({
				url: DORM + "/expense/invoce/check",
				method: "post",
				async: false,
				params: InvoceCheckParamVo

			}).then(res => {
				console.log(res);
				var resParse = JSON.parse(res.data)
				if(resParse.RtnCode == '00') {
					if(resParse.resultCode == '1000') {
						//totalTaxSum 价税合计
						//totalTaxNum 税额
						//totalAmount 金额
						console.log(resParse)
						var fillInfo = JSON.parse(resParse.invoiceResult);
						this.totalTaxSum = fillInfo.totalTaxSum;
						this.totalTaxNum = fillInfo.totalTaxNum;
						this.totalAmount = fillInfo.totalAmount;
						this.fillRise = fillInfo.purchaserName;
						this.fillNumber = fillInfo.taxpayerNumber;
						if(parseFloat(fillInfo.totalTaxSum) == parseFloat(this.fillList[0].fillMone) && parseFloat(fillInfo.totalTaxNum) == parseFloat(this.fillList[0].taxRate) && parseFloat(fillInfo.totalAmount) == parseFloat(this.fillList[0].subtotalAmount) && InvoiceRise == fillInfo.purchaserName && InvoiceNumber == fillInfo.taxpayerNumber) {

							// this.$message('发票验证通过');
							data.invoStatus = '验证已通过'
							data.invoInfo = resParse.resultMsg
							var _this = this;
							var data1 = {
								'reCostinfo': data,
								'fillList': JSON.stringify(this.fillList)
							}
							saveCost(data1).then(response => {
								if(response == 400) {
									Toast({
										message: '同一张发票请勿重复使用',
										position: 'top',
										duration: 1500,
										className: "success"
									});
									$('.newCost').removeAttr('disabled');
									return true;
								} else {
									Toast({
										message: '保存成功',
										position: 'top',
										duration: 1500,
										className: "success"
									});

									data.costDate = data.costDate + '00'
									_this.reimCostList.push(data);
									_this.dataList.splice(0, 0, data)
									_this.alignCost();
								}

								// _this.data.reimCostNumb=this.numAdd(_this.data.reimCostNumb,data.amouMone)
							});

						} else {
							if(InvoiceRise != fillInfo.purchaserName || InvoiceNumber != fillInfo.taxpayerNumber) {
								$('.invoiceDialogVisible').css('display', 'block');
								$('.newCost').removeAttr('disabled');
								return true;
							} else {
								this.fillList[0].fillMone = fillInfo.totalTaxSum;
								this.fillList[0].taxRate = fillInfo.totalTaxNum;
								this.fillList[0].subtotalAmount = fillInfo.totalAmount;
								data.invoStatus = '验证已通过'
								data.invoInfo = resParse.resultMsg
								var data1 = {
									'reCostinfo': data,
									'fillList': JSON.stringify(this.fillList)
								}
								var _this = this;
								var data1 = {
									'reCostinfo': data,
									'fillList': JSON.stringify(this.fillList)
								}
								saveCost(data1).then(response => {
									if(response == 400) {
										Toast({
											message: '同一张发票请勿重复使用',
											position: 'top',
											duration: 1500,
											className: "success"
										});
										$('.newCost').removeAttr('disabled');
										return true;
									} else {
										Toast({
											message: '保存成功',
											position: 'top',
											duration: 1500,
											className: "success"
										});
										data.costDate = data.costDate + '00'
										_this.reimCostList.push(data);
										_this.dataList.splice(0, 0, data)
										_this.alignCost();
									}
								});

							}
						}
					} else if(resParse.resultCode == '2001') {
						// this.$message(resParse.resultMsg);
						data.invoStatus = '验证未通过'
						data.invoInfo = resParse.resultMsg
						var _this = this;
						var data1 = {
							'reCostinfo': data,
							'fillList': JSON.stringify(this.fillList)
						}
						saveCost(data1).then(response => {
							if(response == 400) {
								Toast({
									message: '同一张发票请勿重复使用',
									position: 'top',
									duration: 1500,
									className: "success"
								});
								$('.newCost').removeAttr('disabled');
								return true;
							} else {
								Toast({
									message: '保存成功',
									position: 'top',
									duration: 1500,
									className: "success"
								});
								data.costDate = data.costDate + '00'
								_this.reimCostList.push(data)
								_this.dataList.splice(0, 0, data)
								_this.alignCost();
							}
							// _this.data.reimCostNumb=this.numAdd(_this.data.reimCostNumb,data.amouMone)
						});

					}
				} else if(resParse.RtnCode == '99') {
					// this.$message(resParse.resultMsg);
					data.invoStatus = '未验证'
					data.invoInfo = resParse.resultMsg
					var _this = this;
					var data1 = {
						'reCostinfo': data,
						'fillList': JSON.stringify(this.fillList)
					}
					saveCost(data1).then(response => {
						if(response == 400) {
							Toast({
								message: '同一张发票请勿重复使用',
								position: 'top',
								duration: 1500,
								className: "success"
							});
							$('.newCost').removeAttr('disabled');
							return true;
						} else {
							Toast({
								message: '保存成功',
								position: 'top',
								duration: 1500,
								className: "success"
							});
							data.costDate = data.costDate + '00'
							_this.reimCostList.push(data)
							_this.dataList.splice(0, 0, data)
							_this.alignCost();
						}
						// _this.data.reimCostNumb=this.numAdd(_this.data.reimCostNumb,data.amouMone)
					});

				}

				// this.fileUrl = res[0].dicCode
			});

		},
		//动态添加费用扩展字段
		typeChangeEvent(value) {
			$(".extendInfo").empty();
			var info = {
				'Fid': this.createdCost.costType
			};

			// 获取默认税率
			var obj = this.createdCost.options.find((item) => {
				return item.costTypeName === value;
			});
			// 默认税率
			this.fillList[0].defTaxRate = (obj === undefined ? '' : obj.taxRate);
			this.defaultTaxRate = this.fillList[0].defTaxRate;
			// 计算税额等
			// 清空原有计算
			var item = this.fillList[0];
			item.taxRate = null;
			item.subtotalAmount = null;
			this.totalAmtChange();

			var _this = this;
			costTypeSelect(info).then(response => {
				//sample 文本框
				//single 单选框
				//Number 数字名称
				//provincesCities 省市框
				//Multiline 多行文本框
				//multiSelect 多选文本
				//times 日期框
				//dormitory 宿舍框
				this.costTypefield = [];
				this.costTypeList = response.costTypeMinor;
				for(var i = 0; i < response.costTypeMinor.length; i++) {
					if(response.costTypeMinor[i].fielType == "single" || response.costTypeMinor[i].fielType == "multiSelect") {
						var extend = response.costTypeMinor[i].extend;
						var field = {
							field: response.costTypeMinor[i].prinConc,
							'value': '',
							'extend': extend.split(';')
						};
						this.costTypefield.push(field)
					} else if(response.costTypeMinor[i].fielType == "dataDiction") {
						var extend1 = response.costTypeMinor[i].extend;
						var info = {
							'type': extend1
						}
						var index = i;
						var _this = this;
						var arr = [];
						promise({
							url: DORM + "/expense/selectDictionType",
							method: "get",
							async: false,
							params: {
								type: extend1
							}
						}).then(res => {
							console.log(res);
							if(res.length != 0) {
								for(var K = 0; K < res.length; K++) {
									var file = res[K].dicName;
									arr.push(file)
								}

							}
						});
						var field = {
							field: response.costTypeMinor[index].prinConc,
							'value': '',
							'extend': arr
						};
						_this.costTypefield.push(field)
					} else {
						var field = {
							field: response.costTypeMinor[i].prinConc,
							'value': '',
							'extend': []
						};
						this.costTypefield.push(field)
					}

				}
				console.log(this.costTypefield)
				costInfo = response;
				console.log(response)
				this.createdCost.costIcon = response.costIcon;
			});
		},
		// 发票价税合计改变事件
		totalAmtChange() {
			var item = this.fillList[0];
			this.defaultTaxRate = this.fillList[0].defTaxRate;
			if(item.fillMone !== null && item.fillMone !== undefined && item.fillMone !== '' &&
				item.fillMone.toString().indexOf(' ') === -1) {
				if(this.defaultTaxRate !== null && this.defaultTaxRate !== undefined && this.defaultTaxRate !== '') {
					var totalAmt = 0;
					var taxRate = parseFloat(this.defaultTaxRate) * 0.01;
					totalAmt = parseFloat(item.fillMone);
					item.taxRate = parseFloat((totalAmt * taxRate / (1 + taxRate)).toFixed(2));
					item.subtotalAmount = parseFloat((totalAmt - item.taxRate).toFixed(2));
				}
			} else {
				item.taxRate = null;
				item.subtotalAmount = null;
			}
		},
		//数组去重
		uniq(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++) {
				if(temp.indexOf(array[i]) == -1) {
					temp.push(array[i]);
				} else {
					var index = temp.indexOf(array[i])
					temp.splice(index, 1)
				}
			}
			return temp;
		},
		//数组排序
		sort(arr) {
			for(var j = 0; j < arr.length - 1; j++) {
				//两两比较，如果前一个比后一个大，则交换位置。
				for(var i = 0; i < arr.length - 1 - j; i++) {
					if(arr[i] > arr[i + 1]) {
						var temp = arr[i];
						arr[i] = arr[i + 1];
						arr[i + 1] = temp;
					}
				}
			}
			return arr;
		},
		numFilter(value) {  // 截取当前数据到小数点后两位
			  
			let realVal = Number(value).toFixed(2)   // num.toFixed(2)获取的是字符串
			  
			return Number(realVal) 
		},
		//点击事件，弹出选择摄像头和相册的选项
		showActionSheet() {
			let bts = [{
				title: "拍照"
			}, {
				title: "从相册选择"
			}];
			var _thiss = this
			plus.nativeUI.actionSheet({
					cancel: "取消",
					buttons: bts
				},
				function(e) {
					if(e.index == 1) {
						_thiss.getImage();
					} else if(e.index == 2) {
						_thiss.galleryImgs();
					}
				}
			);
		},
		fileList(fileList) {
			let files = fileList.files;
			for(let i = 0; i < files.length; i++) {
				//判断是否为文件夹
				if(files[i].type != '') {
					this.fileAdd(files[i]);
				} else {
					//文件夹处理
					this.folders(fileList.items[i]);
				}
			}
		},
		//文件夹处理
		folders(files) {
			let _this = this;
			//判断是否为原生file
			if(files.kind) {
				files = files.webkitGetAsEntry();
			}
			files.createReader().readEntries(function(file) {
				for(let i = 0; i < file.length; i++) {
					if(file[i].isFile) {
						_this.foldersAdd(file[i]);
					} else {
						_this.folders(file[i]);
					}
				}
			})
		},
		fileAdd(file) {
			console.log('自带')
			console.log(file)
			//总大小
			this.size = this.size + file.size;
			//判断是否为图片文件
			if(file.type.indexOf('image') == -1) {
				file.src = 'wenjian.png';
				this.imgList.push({
					file
				});
			} else {
				let reader = new FileReader();
				reader.vue = this;
				reader.readAsDataURL(file);
				reader.onload = function() {
					file.src = this.result;
					this.vue.imgList.push({
						file
					});
				}
				console.log(this.imgList)
			}
		},
		fileDel(index) {
			this.size = this.size - this.imgList[index].file.size; //总大小
			this.imgList.splice(index, 1);
			this.imgUrl.splice(index, 1);
		},
		bytesToSize(bytes) {
			if(bytes === 0) {
				return '0 B';
			}
			let k = 1000, // or 1024
				sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
				i = Math.floor(Math.log(bytes) / Math.log(k));
			return(bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
		},
		dragenter(el) {
			el.stopPropagation();
			el.preventDefault();
		},
		dragover(el) {
			el.stopPropagation();
			el.preventDefault();
		},
		drop(el) {
			el.stopPropagation();
			el.preventDefault();
			this.fileList(el.dataTransfer);
		},
		shows(et, tx) {
			this.strut = et;
			this.txt = tx;
		},
		handleClick() {
			this.$store.commit('add')
		},
		//查看费用详情
		seeCostDetail(costType, event, infoFid) {
			console.log(infoFid)
			console.log('详情')
			event.stopImmediatePropagation();
			// console.log(event.currentTarget)
			// console.log(event.target)
			// console.log($(event.currentTarget).find(".extendInfo"))
			var extendInfoTarget = event.currentTarget;
			console.log(infoFid)
			if(infoShowHide == infoFid) {

				infoShowHide = ''
				this.costInfoList = [];
				this.costInfofield = [];
				this.costfillList = [];
				$(event.currentTarget).css('background', 'white')

			} else {
				$('.LookCostDetail').css('background', 'white')
				$(event.currentTarget).css('background', '#F3F4F5')
				$('.extendInfoParents').css('height', '0px');
				$(event.currentTarget).next('.extendInfoParents').css('height', 'auto')

				var thiss = this
				setTimeout(function() {
					infoShowHide = infoFid;
					var fid = {
						'Fid': infoFid
					}
					selectCostDetail(fid).then(response => {
						thiss.costDetail = response
						console.log(thiss.costDetail)
						thiss.costSelectLoad1(costType, extendInfoTarget)
					})
					var fillMainId = {
						'mainId': infoFid
					}
					selectFillList(fillMainId).then(res => {
						thiss.costfillList = res;
						console.log(thiss.costfillList)
					})
				}, 500)
			}

		},
		//点击查看费用
		costSelectLoad1(costType, extendInfoTarget) {
			var info = {
				'Fid': costType
			};
			console.log(costType);
			costTypeSelect(info).then(response => {
				//sample 文本框
				//single 单选框
				//Number 数字名称
				//provincesCities 省市框
				//Multiline 多行文本框
				//multiSelect 多选文本
				//times 日期框
				//dormitory 宿舍框
				this.costInfofield = [];
				if(response.costTypeMinor.length == 0) {
					return true;
				}
				this.costInfoList = response.costTypeMinor;
				for(var i = 0; i < response.costTypeMinor.length; i++) {
					if(response.costTypeMinor[i].fielType == "single" || response.costTypeMinor[i].fielType == "multiSelect") {
						if(response.costTypeMinor[i].fielType == "multiSelect") {
							var prinConc1 = response.costTypeMinor[i].prinConc;
							var prinConctoLowerCase1 = prinConc1.toLowerCase()
							var prinConcSplict1 = prinConctoLowerCase1.split('_')
							for(var k = 1; k < prinConcSplict1.length; k++) {
								prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
							}
							var prinConcData = this.costDetail[prinConcSplict1.join('')];
							console.log(prinConcData);
							var extend = response.costTypeMinor[i].extend;
							if(prinConcData != null) {
								var field = {
									field: response.costTypeMinor[i].prinConc,
									'value': prinConcData.split(','),
									'extend': extend.split(';')
								};
								this.costInfofield.push(field)
							} else {
								var field = {
									field: response.costTypeMinor[i].prinConc,
									'value': '',
									'extend': extend.split(';')
								};
								this.costInfofield.push(field)
							}

						} else {
							var prinConc1 = response.costTypeMinor[i].prinConc;
							var prinConctoLowerCase1 = prinConc1.toLowerCase()
							var prinConcSplict1 = prinConctoLowerCase1.split('_')
							for(var k = 1; k < prinConcSplict1.length; k++) {
								prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
							}
							var prinConcData = this.costDetail[prinConcSplict1.join('')];
							console.log(prinConcData);
							var extend = response.costTypeMinor[i].extend;
							var field = {
								field: response.costTypeMinor[i].prinConc,
								'value': prinConcData,
								'extend': extend.split(';')
							};
							this.costInfofield.push(field)
						}

					} else if(response.costTypeMinor[i].fielType == "dataDiction") {
						var extend1 = response.costTypeMinor[i].extend;
						var info = {
							'type': extend1
						}
						var index = i;
						var _this = this;
						var arr = [];
						promise({
							url: DORM + "/expense/selectDictionType",
							method: "get",
							async: false,
							params: {
								type: extend1
							}
						}).then(res => {
							console.log(res);
							if(res.length != 0) {
								for(var K = 0; K < res.length; K++) {
									var file = res[K].dicName;
									arr.push(file)
								}

							}
						});
						var prinConc1 = response.costTypeMinor[i].prinConc;
						var prinConctoLowerCase1 = prinConc1.toLowerCase()
						var prinConcSplict1 = prinConctoLowerCase1.split('_')
						for(var k = 1; k < prinConcSplict1.length; k++) {
							prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
						}
						var prinConcData = this.costDetail[prinConcSplict1.join('')];
						var field = {
							field: response.costTypeMinor[index].prinConc,
							'value': prinConcData,
							'extend': arr
						};
						_this.costInfofield.push(field)
					} else {
						var prinConc1 = response.costTypeMinor[i].prinConc;
						var prinConctoLowerCase1 = prinConc1.toLowerCase()
						var prinConcSplict1 = prinConctoLowerCase1.split('_')
						for(var k = 1; k < prinConcSplict1.length; k++) {
							prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
						}
						var prinConcData = this.costDetail[prinConcSplict1.join('')];
						var field = {
							field: response.costTypeMinor[i].prinConc,
							'value': prinConcData,
							'extend': []
						};
						this.costInfofield.push(field)
					}

				}
			});

		},
		dealImage(path, callback) {
			var img = new Image();
			img.src = path;
			img.onload = function() {
				//默认按比例压缩
				var w = this.width,
					h = this.height;
				var quality = 0.9; // 默认图片质量为0.7
				console.log('照片宽度')
				console.log(this.width)
				console.log(this.height)
				console.log('值类型')
				console.log(typeof this.width)
				if(w > 4096) {
					w = 4095
				}
				if(h > 4096) {
					h = 4095
				}
				var quality; // 默认图片质量为0.7
				if(w < 1000 || h < 1000) {
					quality = 0.8
					console.log('0.8')
				} else {
					quality = 0.3
					console.log('0.3')
				}

				//生成canvas
				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');

				// 创建属性节点
				canvas.setAttribute("width", w);
				canvas.setAttribute("height", h);

				ctx.drawImage(this, 0, 0, w, h);
				// quality值越小，所绘制出的图像越模糊
				var base64 = canvas.toDataURL('image/jpeg', quality);
				// 回调函数返回base64的值
				callback(base64);
			};
		},

		//********************************************发票上传照片***********************************************//
		//调用相册&相机
		fillFileClick(fillIndex) {
			// $('#upload_file').click();
			this.fillShowActionSheet(fillIndex);
			// this.galleryImgs();

		},
		//调用手机摄像头并拍照
		fillGetImage(fillIndex) {
			var _this = this;
			let cmr = plus.camera.getCamera();
			cmr.captureImage(function(p) {
				console.log('摄像头前')
				console.log(p)
				plus.io.resolveLocalFileSystemURL(p, function(entry) {
					$('.loadingDialog').show();
					$('.costHeight').css('overflow', 'hidden');
					_this.loadingDialog = true;
					var file = {};
					console.log(p)
					plus.zip.compressImage(entry.toLocalURL(), entry.name);
					entry.file(function(path) {
						console.log("P__" + JSON.stringify(path));
						var fileData = JSON.stringify(path);
						file.lastModifiedDate = fileData.lastModifiedDate;
						var reader = new plus.io.FileReader();
						reader.readAsDataURL(path);
						reader.onloadend = function(event) {
							console.log(event)
							var base64 = event.target.result;
							_this.dealImage(base64, function(base) {
								//直接将获取到的base64的字符串，放到一个image标签中就可看到测试后的压缩之后的样式图了
								// document.getElementById("transform").src = base;
								file.src = base;
								// console.log("压缩后：" + base.length / 1024 + " " + base);　　　　
							})
							var fileName = event.target.fileName;
							if(fileName.indexOf("/") >= 0) //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
							{
								file.name = fileName.substring(fileName.lastIndexOf("/") + 1, fileName.length);
							} else {
								file.name = fileName;
							}
							var blob, jsonFile
							setTimeout(function() {
								blob = _this.dataURLtoBlob(file.src);
								jsonFile = _this.blobToFile(blob, file.name)
								console.log('jsonFile')
								console.log(jsonFile.filename)
							}, 2000)
							setTimeout(function() {
								var formData = new FormData();
								formData.append("file", jsonFile);
								formData.append("infoFid", _this.data.infoFid);
								formData.append("direCode", 'costTest');
								promise({
									url: JPT_URL + "/zuul" + BASIC + '/doc/upload',
									method: "post",
									async: true,
									data: formData,
								}).then(response => {
									console.log('调用成功')
									console.log(response);
									_this.fillList[fillIndex].fillImgUrl = response.data[0].fileUrl
									_this.$previewRefresh()
									_this.loadingDialog = false;
									$('.loadingDialog').hide();
									$('.costHeight').css('overflow', 'auto');
									$('.fillImg').removeClass('displNone')
								});
							}, 3000)
						};
					})
				}, function(e) {
					plus.nativeUI.toast("读取拍照文件错误：" + e.message);
				});
			}, function(e) {}, {
				filter: 'image'
			});
		},
		//从相册选择照片
		fillGalleryImgs(fillIndex) {
			var _this = this;
			console.log(_this.imgList)
			plus.gallery.pick(function(e) {
				console.log(e)
				let name = e.substr(e.lastIndexOf('/') + 1);
				console.log(name)
				plus.zip.compressImage(e, name);
				console.log('相册')
				plus.io.resolveLocalFileSystemURL(e, function(entry) {
					$('.loadingDialog').show();
					$('.costHeight').css('overflow', 'hidden');
					_this.loadingDialog = true;
					var file = {};
					console.log(e)
					plus.zip.compressImage(entry.toLocalURL(), entry.name);
					// console.log('相册')
					// console.log(entry)
					// console.log('相册base64')
					entry.file(function(path) {
						console.log("P__" + JSON.stringify(path));
						var fileData = JSON.stringify(path);
						file.lastModifiedDate = fileData.lastModifiedDate;
						var reader = new plus.io.FileReader();
						reader.readAsDataURL(path);
						reader.onloadend = function(event) {
							console.log(event)
							var base64 = event.target.result;
							_this.dealImage(base64, function(base) {
								//直接将获取到的base64的字符串，放到一个image标签中就可看到测试后的压缩之后的样式图了
								// document.getElementById("transform").src = base;
								file.src = base;
								// console.log("压缩后：" + base.length / 1024 + " " + base);　　　　
							})
							// file.src=event.target.result;
							var fileName = event.target.fileName;
							if(fileName.indexOf("/") >= 0) //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
							{
								file.name = fileName.substring(fileName.lastIndexOf("/") + 1, fileName.length);
							} else {
								file.name = fileName;
							}
							var blob, jsonFile
							setTimeout(function() {
								blob = _this.dataURLtoBlob(file.src);
								jsonFile = _this.blobToFile(blob, file.name)
								console.log('jsonFile')
								console.log(jsonFile.filename)
							}, 2000)
							setTimeout(function() {
								var formData = new FormData();
								formData.append("file", jsonFile);
								formData.append("infoFid", _this.data.infoFid);
								formData.append("direCode", 'costTest');
								promise({
									url: JPT_URL + "/zuul" + BASIC + '/doc/upload',
									method: "post",
									async: true,
									data: formData,
								}).then(response => {
									console.log('调用成功')
									console.log(response);
									_this.fillList[fillIndex].fillImgUrl = response.data[0].fileUrl
									_this.$previewRefresh()
									_this.loadingDialog = false;
									$('.loadingDialog').hide();
									$('.costHeight').css('overflow', 'auto');
									$('.fillImg').removeClass('displNone')
								});
							}, 3000)
						};
					})
				}, function(e) {
					plus.nativeUI.toast("读取拍照文件错误：" + e.message);
				});
			}, function(e) {}, {
				filter: "image"
			});

		},
		//点击事件，弹出选择摄像头和相册的选项
		fillShowActionSheet(fillIndex) {
			let bts = [{
				title: "拍照"
			}, {
				title: "从相册选择"
			}];
			var _thiss = this
			plus.nativeUI.actionSheet({
					cancel: "取消",
					buttons: bts
				},
				function(e) {
					if(e.index == 1) {
						_thiss.fillGetImage(fillIndex);
					} else if(e.index == 2) {
						_thiss.fillGalleryImgs(fillIndex);
					}
				}
			);
		},
		//********************************************发票上传照片识别信息***********************************************//
		//调用相册&相机
		fileDistingClick() {

			this.fillDistingShowActionSheet();
			// this.galleryImgs();

		},
		//调用手机摄像头并拍照
		fillDistingGetImage() {
			var _this = this;
			let cmr = plus.camera.getCamera();
			cmr.captureImage(function(p) {
				console.log('摄像头前')
				console.log(p)
				plus.io.resolveLocalFileSystemURL(p, function(entry) {
					$('.loadingDialog').show();
					$('.costHeight').css('overflow', 'hidden');
					_this.loadingDialog = true;
					var file1 = {};
					console.log(p)
					plus.zip.compressImage(entry.toLocalURL(), entry.name);
					entry.file(function(path) {
						console.log("P__" + JSON.stringify(path));
						var fileData = JSON.stringify(path);
						// file1.lastModifiedDate=fileData.lastModifiedDate;
						var reader = new plus.io.FileReader();
						reader.readAsDataURL(path);
						reader.onloadend = function(event) {
							console.log(event)
							var base64 = event.target.result;
							_this.fillSubMit(base64, event.target.fileName)
						};
					})
				}, function(e) {
					plus.nativeUI.toast("读取拍照文件错误：" + e.message);
				});
			}, function(e) {}, {
				filter: 'image'
			});
		},
		//从相册选择照片
		fillDistingGalleryImgs() {
			var _this = this;
			console.log(_this.imgList)
			plus.gallery.pick(function(e) {
				console.log(e)
				let name = e.substr(e.lastIndexOf('/') + 1);
				console.log(name)
				plus.zip.compressImage(e, name);
				console.log('相册')
				plus.io.resolveLocalFileSystemURL(e, function(entry) {
					$('.loadingDialog').show();
					$('.costHeight').css('overflow', 'hidden');
					_this.loadingDialog = true;
					var file = {};
					console.log(e)
					plus.zip.compressImage(entry.toLocalURL(), entry.name);
					// console.log('相册')
					// console.log(entry)
					// console.log('相册base64')
					entry.file(function(path) {
						console.log("P__" + JSON.stringify(path));
						var fileData = JSON.stringify(path);
						file.lastModifiedDate = fileData.lastModifiedDate;
						var reader = new plus.io.FileReader();
						reader.readAsDataURL(path);
						reader.onloadend = function(event) {
							console.log(event)
							var base64 = event.target.result;
							_this.fillSubMit(base64, event.target.fileName)
						};
					})
				}, function(e) {
					plus.nativeUI.toast("读取拍照文件错误：" + e.message);
				});
			}, function(e) {}, {
				filter: "image"
			});

		},
		//点击事件，弹出选择摄像头和相册的选项
		fillDistingShowActionSheet() {
			let bts = [{
				title: "拍照"
			}, {
				title: "从相册选择"
			}];
			var _thiss = this
			plus.nativeUI.actionSheet({
					cancel: "取消",
					buttons: bts
				},
				function(e) {
					if(e.index == 1) {
						_thiss.fillDistingGetImage();
					} else if(e.index == 2) {
						_thiss.fillDistingGalleryImgs();
					}
				}
			);
		},
		projNameChange(code) {
			console.log(code)
			var obj = {}
			obj = this.projectList.find((item) => {
				return item.projCode === code;
			});
			console.log(obj)
			this.data.projName = obj.projName;
		},
		reimMone() {
			// MessageBox('提示', '金额自动填充,无需填写');
		},
		//发票新增
		createFill() {
			var fillcreate = {
				fillCode: '',
				fillNumb: '',
				fillMone: '',
				fillTime: '',
				fillImg: '',
				fillImgUrl: '',
				checkCode: '',
				subtotalAmount: '',
				taxRate: ''
			}
			this.fillList.push(fillcreate);
		},
		alignCost() {
			$('.newCost').removeAttr('disabled');
			$(".extendInfo").empty();
			costInfo = '';
			this.createdCost.userType = '';
			this.createdCost.date = undefined;
			var myDate = new Date()
			this.createdCost.costDate = formatTime(myDate, 'yyyy-MM-dd hh:mm:ss');
			this.createdCost.AtypeText = '';
			this.createdCost.costType = '';
			this.createdCost.dateOccu = '';
			this.createdCost.amouMone = '';
			this.createdCost.costIcon = '';
			this.createdCost.bRemarks = '';
			this.costTypeList = [];
			this.fillList = [{
				fillCode: '',
				fillNumb: '',
				fillMone: '',
				fillTime: '',
				fillImg: '',
				fillImgUrl: '',
				checkCode: '',
				subtotalAmount: '',
				taxRate: ''
			}];
			setTimeout(function() {
				$('.fillImg').addClass('displNone')
			}, 100)
		},
		costToole() {
			setTimeout(function() {
				page = 1;
				limit = 10;
				var pageLimit = {
					'page': page,
					'limit': limit,
					'reimType': reimType,
					'reimCost': diagcostinfoList
				}
				selectMainIdCostList(pageLimit).then(response => {
					console.log(response)
					this.dataList = response.data;
				})
			}, 200)
			$('.createdCost').animate({
				bottom: '-120%'
			}, 500)
			$('.costDiloagListDiv').css('display', 'block')
			setTimeout(function() {
				$('.createdCost').hide()
			}, 500)
			$(".extendInfo").empty();
			costInfo = '';
			this.createdCost.userType = '';
			this.createdCost.date = undefined;
			this.createdCost.AtypeText = '';
			this.createdCost.costType = '';
			this.createdCost.dateOccu = '';
			this.createdCost.amouMone = '';
			this.createdCost.costIcon = '';
			this.createdCost.bRemarks = '';
			this.createdCost.invoType = '';
			this.costTypeList = [];
			this.fillList = [];
			$('.costListDiv').css('display', 'block')
		},
		dataURLtoBlob(dataurl) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while(n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			console.log('blob')
			return new Blob([u8arr], {
				type: mime
			});
		},
		//将blob转换为file
		blobToFile(theBlob, fileName) {
			var objFile = new File([theBlob], fileName, {
				type: "image/jpeg"
			});
			console.log(fileName)
			// theBlob.lastModifiedDate = new Date();
			// theBlob.filename = fileName;
			console.log('file')
			return objFile;
		},
		numSub(num1, num2) {
			var baseNum, baseNum1, baseNum2;
			var precision; // 精度
			try {
				baseNum1 = num1.toString().split(".")[1].length;
			} catch(e) {
				baseNum1 = 0;
			}
			try {
				baseNum2 = num2.toString().split(".")[1].length;
			} catch(e) {
				baseNum2 = 0;
			}
			baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
			precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
			return((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
		},
		numAdd(num1, num2) {
			var baseNum, baseNum1, baseNum2;
			try {
				baseNum1 = num1.toString().split(".")[1].length;
			} catch(e) {
				baseNum1 = 0;
			}
			try {
				baseNum2 = num2.toString().split(".")[1].length;
			} catch(e) {
				baseNum2 = 0;
			}
			baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
			return(num1 * baseNum + num2 * baseNum) / baseNum;
		},
		createdFile(src, name, callback) {
			console.log('打印回调函数')
			var blob, jsonFile
			blob = this.dataURLtoBlob(src);
			jsonFile = this.blobToFile(blob, name)
			console.log('jsonFile')
			console.log(jsonFile.filename)
			callback(jsonFile, this.data.infoFid);
		},
		fillSubMit(base64, fileName) {
			var _this = this;
			var file = {}
			if(fileName.indexOf("/") >= 0) //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
			{
				file.name = fileName.substring(fileName.lastIndexOf("/") + 1, fileName.length);
			} else {
				file.name = fileName;
			}
			this.dealImage(base64, function(base) {
				//直接将获取到的base64的字符串，放到一个image标签中就可看到测试后的压缩之后的样式
				console.log('yasuo')
				file.src = base;

				_this.createdFile(file.src, file.name, function(jsonFile, infoFid) {
					console.log('开始请求后台')
					console.log(new Date() + '开始')
					var fillfillcreate = {};
					// 保留发票类型
					fillfillcreate.invoTypeCode = _this.fillList[0].invoTypeCode;
					fillfillcreate.invoTypeName = _this.fillList[0].invoTypeName;
					fillfillcreate.isCheck = _this.fillList[0].isCheck;
					fillfillcreate.defTaxRate = _this.fillList[0].defTaxRate;
					var formData = new FormData();
					formData.append("file", jsonFile);
					formData.append("infoFid", infoFid);
					formData.append("direCode", 'costTest');
					console.log(new Date() + '中间')
					promise({
						url: JPT_URL + "/zuul" + BASIC + '/doc/upload',
						method: "post",
						data: formData,
					}).then(response => {
						console.log(new Date() + '结尾')
						console.log('调用成功')
						console.log(response);
						console.log(response.data[0].fileUrl)
						fillfillcreate.fillImgUrl = response.data[0].fileUrl

					});
					console.log('识别照片')
					promise({
						url: JPT_URL + "/zuul" + DORM + '/expense/invoce/discern',
						method: "post",
						async: false,
						data: formData
					}).then(response => {
						if(response.code != 0) {
							if(response.code == 400) {
								Toast({
									message: response.msg,
									position: 'top',
									duration: 1500,
									className: "error"
								});
								_this.loadingDialog = false;
								$('.loadingHeight').css('display', 'none')
								$('.costHeight').css('overflow', 'auto');
							} else {
								console.log('解析失败信息')
								console.log(response.error_msg)
								Toast({
									message: '图片模糊请重新上传',
									position: 'top',
									duration: 1500,
									className: "error"
								});
								_this.loadingDialog = false;
								$('.costHeight').css('overflow', 'auto');
								$('.loadingHeight').css('display', 'none')
							}
							return
						} else {
							var data = JSON.parse(response.data)
							console.log('发票识别信息')
							console.log(response.data);
							console.log(data);
							fillfillcreate.fillCode = data.data['发票代码'];
							fillfillcreate.fillNumb = data.data['发票号码'];
							fillfillcreate.fillMone = data.data['发票金额'];
							fillfillcreate.checkCode = data.data['校验码'];
							fillfillcreate.subtotalAmount = data.data['不含税金额'];
							fillfillcreate.taxRate = data.data['发票税额'];
							fillfillcreate.fillTime = data.data['开票日期'].replace('年', '-').replace('月', '-').replace('日', '')
							_this.fillList.splice(0, 1)
							_this.fillList.push(fillfillcreate)
							_this.$previewRefresh()
							_this.loadingDialog = false;
							$('.loadingHeight').css('display', 'none')
							$('.costHeight').css('overflow', 'auto');
							setTimeout(function() {
								$('.fillImg').removeClass('displNone')
							}, 100)
						}
					});
				})　　　
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/reimDetail.vue